export const TOKEN_KEYS = {
  AUTH_TOKEN_KEY: 'auth_token',
}

export const REPEAT_SEND_CODE_TIMEOUT = 60000
